export default __webpack_public_path__ + "static/media/testPurchase.99941930.png";